import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LetterAvatarComponent } from './letter-avatar.component';

@NgModule({
  imports: [CommonModule],
  declarations: [LetterAvatarComponent],
  exports: [LetterAvatarComponent]
})
export class LetterAvatarModule {}
